webpackJsonp([267695594480457],{

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rlaComponents = __webpack_require__(7);
	
	var _theme = __webpack_require__(6);
	
	var _HeaderBlock = __webpack_require__(15);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _PageDetailContainer = __webpack_require__(46);
	
	var _PageDetailContainer2 = _interopRequireDefault(_PageDetailContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsPage = function (_React$Component) {
	    _inherits(TermsPage, _React$Component);
	
	    function TermsPage() {
	        _classCallCheck(this, TermsPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    TermsPage.prototype.componentDidMount = function componentDidMount() {
	        setTimeout(function () {
	            window.dispatchEvent(new Event("load"));
	        }, 0);
	    };
	
	    TermsPage.prototype.render = function render() {
	        var transition = this.props.transition;
	
	        return _react2.default.createElement(
	            "div",
	            { style: transition && transition.style },
	            _react2.default.createElement(
	                _PageDetailContainer2.default,
	                null,
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(
	                        _rlaComponents.Column,
	                        null,
	                        _react2.default.createElement(
	                            _HeaderBlock2.default,
	                            {
	                                textAlign: "left",
	                                baseColor: _theme.colors.background,
	                                fontSize: 3,
	                                padding: {
	                                    top: 0.6,
	                                    right: 0,
	                                    bottom: 2.4,
	                                    left: 0
	                                }
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                "Terms "
	                            ),
	                            "& Conditions"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _rlaComponents.Row,
	                    null,
	                    _react2.default.createElement(_rlaComponents.Column, null)
	                )
	            )
	        );
	    };
	
	    return TermsPage;
	}(_react2.default.Component);
	
	exports.default = TermsPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-3314331a7940d31aed35.js